import { render, staticRenderFns } from "./UInput2.vue?vue&type=template&id=beac9a78&scoped=true&"
import script from "./UInput2.vue?vue&type=script&lang=js&"
export * from "./UInput2.vue?vue&type=script&lang=js&"
import style0 from "./UInput2.vue?vue&type=style&index=0&id=beac9a78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beac9a78",
  null
  
)

export default component.exports